import React from 'react';
import { Container, Heading } from 'react-bulma-components';
import { Link } from 'react-router-dom';

import style from './AboutSection.module.scss';
import classNames from 'classnames';

export const AboutSection = () => {
  return (
    <Container className={style.container}>
      <Heading
        size={2}
        className={style.title}
      >
        Про Пласт
      </Heading>

      <Heading
        subtitle
        className={style.subtitle}
      >
        Пласт – це унікальна організація, що відіграє важливу роль у вихованні
        української молоді. Заснований в далекому 1911 році, він поєднує в собі
        ідеали патріотизму, християнської моралі та скаутського руху. Головна
        мета Пласту – це всебічний розвиток особистості, формування свідомих та
        відповідальних громадян, готових служити своїй країні та суспільству.
      </Heading>

      <img
        src="https://wpapi.plastlindenhurst.org/wp-content/uploads/2025/02/Plast-Lindenhurst-LOGO.jpg"
        alt="about plast image"
        className={classNames('pb-5', style.image)}
      />

      <Link
        className={classNames('button', style.button)}
        to="https://plastusa.org/about/"
        color="primary"
        target="_blank"
      >
        Дізнайся більше
      </Link>
    </Container>
  );
};

<article className={classNames('pb-5', style.body)}>
  <p>
    Пласт – це унікальна організація, що відіграє важливу роль у вихованні
    української молоді. Заснований в далекому 1911 році, він поєднує в собі
    ідеали патріотизму, християнської моралі та скаутського руху. Головна мета
    Пласту – це всебічний розвиток особистості, формування свідомих та
    відповідальних громадян, готових служити своїй країні та суспільству.
  </p>

  <p>
    Основними принципами, на яких базується діяльність Пласту, є вірність Богу
    та Україні, допомога іншим, життя за Пластовим Законом та постійний
    саморозвиток. Ці цінності є фундаментом для виховання молоді, яка прагне
    бути корисною та активною у своїй громаді. Пластуни вчаться бути чесними,
    дисциплінованими, відповідальними та завжди готовими допомогти тим, хто
    цього потребує.
  </p>

  <p>
    Пласт пропонує своїм членам широкий спектр можливостей для розвитку та
    самореалізації. Різноманітні заходи та програми, такі як табори, походи,
    майстер-класи та громадські проекти, допомагають молоді розвивати лідерські
    якості, командний дух та практичні навички. Пластуни вчаться працювати
    разом, долати труднощі та досягати поставлених цілей, що є важливим для
    успіху в сучасному світі.
  </p>

  <p>
    Сьогодні Пласт – це потужна організація, що діє не тільки в Україні, але й у
    багатьох країнах світу, об&apos;єднуючи українську молодь навколо спільної
    мети – побудови кращого майбутнього для України. Пласт виховує покоління
    патріотів, лідерів та активних громадян, які готові взяти на себе
    відповідальність за долю своєї країни та зробити свій внесок у її розвиток.
  </p>
</article>;
